import { Button } from "@/components/ui/Button";

const NotFoundPage = () => {
  return (
    <div className="from-background to-muted flex min-h-screen flex-col items-center justify-center bg-gradient-to-b p-4 text-center">
      <div className="w-full max-w-md space-y-8">
        <div className="relative h-64 w-full">
          <img
            src="/src/assets/404-dark.svg"
            alt="404 Illustration"
            className="h-full w-full object-contain"
          />
        </div>
        <p className="text-muted-foreground text-xl">
          We couldn't find the page you're looking for. It might have been moved
          or doesn't exist.
        </p>
        <Button asChild className="mt-8">
          <a href="/">Return to Home</a>
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
